import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    accordions: [],
    isMobile: navigator.maxTouchPoints
      ? !!(navigator.userAgent.match(/Android/i) ||
      navigator.userAgent.match(/webOS/i) ||
      navigator.userAgent.match(/iPhone/i) ||
      navigator.userAgent.match(/iPad/i) ||
      navigator.userAgent.match(/iPod/i) ||
      navigator.userAgent.match(/BlackBerry/i) ||
      navigator.userAgent.match(/Windows Phone/i)) && (navigator.maxTouchPoints > 0)
      : !!(navigator.userAgent.match(/Android/i) ||
        navigator.userAgent.match(/webOS/i) ||
        navigator.userAgent.match(/iPhone/i) ||
        navigator.userAgent.match(/iPad/i) ||
        navigator.userAgent.match(/iPod/i) ||
        navigator.userAgent.match(/BlackBerry/i) ||
        navigator.userAgent.match(/Windows Phone/i)),
    navBarStatus: 'invisible',
    isMobileHomeVisible: undefined
  },
  mutations: {
    cleanAccordionsArr (state) {
      state.accordions = []
    },
    saveAccordions (state, accordions) {
      state.accordions.push(...accordions)
    },
    changeNavBarStatus (state, navBarStatus) {
      state.navBarStatus = navBarStatus
    },
    changeMobileHomeVisibility (state, isVisible) {
      state.isMobileHomeVisible = isVisible
    },
    decideWhatHomeToRender (state) {
      state.isMobileHomeVisible = state.isMobile
    }
  },
  actions: {
    cleanAccordionsArr ({ commit }) {
      commit('cleanAccordionsArr')
    },
    saveAccordions ({ commit }, accordions) {
      commit('saveAccordions', accordions)
    },
    changeNavBarStatus ({ commit }, navBarStatus) {
      commit('changeNavBarStatus', navBarStatus)
    },
    changeMobileHomeVisibility ({ commit }, isVisible) {
      commit('changeMobileHomeVisibility', isVisible)
    },
    decideWhatHomeToRender ({ commit }) {
      commit('decideWhatHomeToRender')
    }
  }
})
